export default __webpack_public_path__ + "img/eKmJQTJm.db147cd3.svg";